import BaseResource from './BaseResource'

export default class Printers extends BaseResource {
  static endpoint = '/api/v1/printers' ///edge
}
